import { render, staticRenderFns } from "./CTA.vue?vue&type=template&id=5b078a38&scoped=true&"
import script from "./CTA.vue?vue&type=script&lang=js&"
export * from "./CTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b078a38",
  null
  
)

export default component.exports